import React from 'react';
import './Features.css';

const Features = () => {
  const featureItems = [
    {
      icon: '🧩',
      title: 'Block-Based Programming',
      description: 'Intuitive drag-and-drop interface makes programming accessible for beginners without writing code.'
    },
    {
      icon: '🤖',
      title: 'Physical Computing',
      description: 'Connect programming concepts to real-world actions with a robot you build yourself.'
    },
    {
      icon: '🧠',
      title: 'Computational Thinking',
      description: 'Develop problem-solving skills through decomposition, pattern recognition, and algorithm design.'
    }
  ];

  return (
    <section id="features" className="section features-section">
      <div className="container">
        <div className="section-title">
          <h2>Why Nozomi Robotics?</h2>
          <p>Designed with learning principles at its core</p>
        </div>

        <div className="features-grid">
          {featureItems.map((feature, index) => (
            <div className="feature-card" key={index}>
              <div className="feature-icon">
                <span>{feature.icon}</span>
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;